import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from './hooks/useCurrentUser';
import { MainLayout } from './components/layout/MainLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Courriers } from './pages/Courriers';
import { CourrierDetail } from './pages/CourrierDetail';
import { CourrierCreate } from './pages/CourrierCreate';
import Organisations from './pages/Organisations';
import { Users } from './pages/Users';
import Perimeters from './pages/Perimeters';

// Loader simple sans animation
function ModernLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50">
      <div className="glass-card rounded-2xl p-8 flex flex-col items-center space-y-4">
        <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full" />
        <p className="text-gray-600 font-medium">Chargement...</p>
      </div>
    </div>
  );
}

// Composant de protection des routes
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useCurrentUser();

  if (isLoading) {
    return <ModernLoader />;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

// Composant pour les routes publiques
function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useCurrentUser();

  if (isLoading) {
    return <ModernLoader />;
  }

  return !isAuthenticated ? <>{children}</> : <Navigate to="/dashboard" replace />;
}

// Layout protégé sans animation
function ProtectedLayout() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Route publique - Login */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* Routes protégées avec layout commun */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ProtectedLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="courriers" element={<Courriers />} />
          <Route path="courriers/create" element={<CourrierCreate />} />
          <Route path="courriers/:id" element={<CourrierDetail />} />
          <Route path="organisations" element={<Organisations />} />
          <Route path="users" element={<Users />} />
          <Route path="perimeters" element={<Perimeters />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
